import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getProducts, reset } from '../features/product/productSlice';
import ProductGrid from '../components/ProductGrid';
import Loading from '../components/Loading';
import shop_bg from '../img/shop-bg.avif';

const MARKET_STORAGE_KEY = 'liviiart_market';

function Shop() {
  const dispatch = useDispatch();
  const { products, isLoading } = useSelector((state) => state.product);
  const market = sessionStorage.getItem(MARKET_STORAGE_KEY);
  

  useEffect(() => {
    dispatch(getProducts(market));
    
    return () => {
      dispatch(reset());
    };
  }, [dispatch, market]);

  if (isLoading) {
    return <Loading />;
  }
  
  return (
    <div className="shop-container">
      <div className="shop-header" style={{ backgroundImage: `url(${shop_bg})` }}></div>
      
      <div className="shop-content">
        {products && products.length > 0 ? (
          <ProductGrid products={products} />
        ) : (
          <div className="no-products">
            <p>No products available at the moment.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Shop;
